<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div [formGroup]="group">
  <profile-pds-p-select
    p-select
    [dropdownDirection]="'auto'"
    [id]="model.id"
    [filter]="this.mode === 'SEARCH'"
    [label]="model.label ?? undefined"
    [description]="model.description ?? undefined"
    [state]="!!showErrorMessages ? 'error' : 'none'"
    [message]="errorMessages[0]"
    [formControlName]="model.id"
    [name]="model.id"
    [required]="model.required"
    [tabindex]="model.tabIndex"
  >
    @if (hasDeselection) {
      <profile-pds-p-select-option p-select-option>{{ deselectionLabel }}</profile-pds-p-select-option>
    }
    @for (item of this.renderItems; track item) {
      @if (isGroupRenderItem(item)) {
        <profile-pds-p-optgroup p-optgroup [label]="item.group">
          @for (option of item.options; track option) {
            <profile-pds-p-select-option p-select-option [value]="option.value" [disabled]="option.disabled">
              {{ option.label }}
            </profile-pds-p-select-option>
          }
        </profile-pds-p-optgroup>
      } @else {
        <profile-pds-p-select-option p-select-option [value]="item.option.value" [disabled]="item.option.disabled">
          {{ item.option.label }}
        </profile-pds-p-select-option>
      }
    }
  </profile-pds-p-select>
</div>
